/**
 * Created by Marcus Zhao on 02/6/2020.
 *  Description:
 *  New Contact Dialog .Load template from Server
 *  Save Contact to Server
 *  Add _createContactRelationType
 * ------ maintenance history ------
 *  2020/3/9 Bowen: add the employment and relationships to contact dialog
 *  2020/4/12 Bowen: edit relationship and employment part
 *  2020/6/3 Bowen: add the dynamic layout for employment and relationship part
 *      because the 2 parts are different from basic information: we just can change the basic information in RC
 *      but for the relationship, we can change it in RC and web, so, we need to add the logic for the 2 parts
 *  07/14/2020 Marcus add createRelationship by restful api
 */
import { Component, OnInit, ElementRef, Renderer2, OnDestroy, AfterViewInit, ViewContainerRef, ViewChild, ComponentRef, Input } from '@angular/core';
import { ContactActions } from '@tamalelibs/constants/business.constants';
import { Subscription, Subject, of, ReplaySubject, Observable, forkJoin, fromEvent } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { ContactTemplateService } from './contact-template.service';
import { ContactTemplateOpenOptions, ContactTemplateType, ControlId, JobTitleAction, CompanyAction, ContactRelationshipType, RelationshipAction, NavigationAction, EmailAction } from './contact-dialog.model';
import { ContactViewModel } from '@tamalelibs/components/contact.view-model';
import { Contact } from '@tamalelibs/models/contact.model';
import { WebTemplateViewModel } from '../template/template-web.view-model';
import { JobFunction, AddressDetail, EmploymentDetail, RelationshipDetail, EmailDetail, PhoneDetail, SocialMedia } from '@tamalelibs/models/job-function';
import { ContactService } from '@tamalelibs/services/contact.service';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../redux';
import { lastCustomActionSelector } from '../../redux/reducers/action-history.reducer';
import { CREATE_CONTACT_SUCCESS, EDIT_CONTACT_SUCCESS } from '@tamalelibs/redux/app.actions';
import { RelationshipService } from '@tamalelibs/services/relationship.service';
import { catchError, take } from 'rxjs/operators';
import * as _lodash from 'lodash';
import { ContactTemplateControlValue } from '@tamalelibs/models/contact-template-control-value.model';
import { ChangeContactTemplateValueSet, CLEAR_JOB_TITLE, REMOVE_JOB_TITLE, ChangeContactTemplateLayoutSet } from '@tamalelibs/redux/contact.actions';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { EntityBack } from '../entity-dialog/entity-dialog.model';
import { OpenDynamicComponentService } from '../../pages/home/home-open-dynamic-component';
import { NotificationStyles, NotificationOptions } from '../../widgets/notification/notification.model';
import { ToastService } from '../../widgets/toast/toast.service';
import { EntityType } from '@tamalelibs/models/entity-type.model';
import { RelationshipTypeActionTypes } from '../../redux/actions/relationship-type.actions';
import { RelationshipType } from '@tamalelibs/models/relationship-type.model';
import { ContactRelationshipService } from '@tamalelibs/services/contact.relationship.service';
import { Entity } from '@tamalelibs/models/entity.model';
import { SystemUser } from '@tamalelibs/models/user.model';
import { StoreQuerierService } from '../../services/store-querier.service';
import { contactNewAddedJobTitleSelector } from '@tamalelibs/redux/contact.reducer';
import { DuplicatedContactDialogService } from '../duplicated-contact-dialog/duplicated-contact-dialog.service';
import { DialogAction } from './../../widgets/tam-dialog/tam-dialog.model';
import { DuplicatedContactItemConfig, DuplicatedContactItemConfigField } from '../duplicated-contact-dialog/duplicated-item/duplicated-item.model';
import { businessConstants } from '@tamalelibs/constants/business.constants';
import { HomeViewModel } from '../../pages/home/home-view.model';
import { ArrayHelperService } from '@tamalelibs/services/array-helper.service';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'contact-dialog-crm',
    templateUrl: './contact-dialog.component.html',
    styleUrls: ['./contact-dialog.component.scss'],
    providers: [WebTemplateViewModel],
    standalone: false
})
export class ContactDialogComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() id;
    viewContainer: ViewContainerRef;
    @ViewChild('flyContainer', { static: false, read: ViewContainerRef }) container: ViewContainerRef;
    componentRef: ComponentRef<ContactDialogComponent>;
    opened: boolean;
    dialogWidth = 732;
    titleName: string;
    isShow = false;
    currentTab = 0;
    tplConfig: any;
    navigationConfig: any;
    currentContact: Contact; // contact model
    dialogOpenOptions: any;
    currentContactRelationshipAndEmployment: any;
    valueChangeSubject: Subject<ContactTemplateControlValue>;
    config: any;
    isDuplicatedContact = false;

    private _action = ContactActions.createContact;
    private _el: HTMLElement;
    private _contactTemplateValueSet: any = {}; // mark the template control's values, based on controlId;
    private _destroySubscriptions: Array<Subscription> = [];
    private _dialogCloseDestroySubscriptions: Array<Subscription> = [];
    private _relationshipTypes: string;
    private _addedFormerEmploymentCtrlGroupId = []; // when change company, need to save the groupid for new added former employment control
    private _currentRelationshipArray = [];
    private _isRelationshipControlValueChanged = false;
    private _contactToEntities = businessConstants.EntityTypes.Contact_Id;
    private _currentUser: SystemUser;
    private _contactEmailGroupIds;
    private _dialogLabelArray = [];
    // this 2 vars are for detect the duplicate controls
    // one is to store all the duplicate information from server
    // current, once detect the contact is a duplicate contact, will stop to research
    private _duplicatedContactInfo: Array<DuplicatedContactItemConfig> = [];
    // one is to store all the duplicate controls from UI
    // mainly to handle: when one control is duplicate, and then input another control(will stop validating), and then modify the duplicate control, need to validate again
    private _duplicatedControls = [];
    constructor(
        private _element: ElementRef,
        private _renderer: Renderer2,
        private _contactTemplateService: ContactTemplateService,
        private _contactService: ContactService,
        private _contactViewModel: ContactViewModel,
        private _store: Store<AppState>,
        private _relationshipService: RelationshipService,
        private _alertWindow: AlertWindowService,
        private _openDynamicComponentService: OpenDynamicComponentService,
        private _toast: ToastService,
        private _contactRelationshipService: ContactRelationshipService,
        private _storeQuerierService: StoreQuerierService,
        private _duplicatedContactDialogService: DuplicatedContactDialogService,
        private _homeViewModel: HomeViewModel,
    ) {
        this._el = this._element.nativeElement;
        this._currentUser = this._storeQuerierService.getCurrentUser();
    }

    ngOnInit() {
        const isIEOrEdgeOrFirefox = /msie\s|trident\/|firefox\/|edge\//i.test(window.navigator.userAgent);
        if (isIEOrEdgeOrFirefox) {
            this.dialogWidth = 738;
        }

        this._store.pipe(select(lastCustomActionSelector),
        ).subscribe(action => this._actionMessageHandler(action));
        this._destroySubscriptions.push(
            this._contactTemplateService.dialogOpen$.subscribe((dialogOpenOptions: ContactTemplateOpenOptions) => {
                if (this.id === dialogOpenOptions.instanceId) {
                    this.dialogOpenOptions = dialogOpenOptions;
                    this.opened = true;
                    this.titleName = dialogOpenOptions.openType;
                    this.navigationConfig = this.dialogOpenOptions.instanceId;
                    this.valueChangeSubject = new ReplaySubject<ContactTemplateControlValue>(10);
                    this._destroySubscriptions.push(
                        this.valueChangeSubject.pipe(
                            filter(res =>
                                res.ctrl.controlID === 'AddPhoneNumber' ||
                                res.ctrl.controlID === 'AddEmail' ||
                                res.ctrl.controlID === 'AddAddress' ||
                                res.ctrl.controlID === 'trash' ||
                                res.ctrl.controlID === 'AddInternetInfo' ||
                                res.ctrl.controlID === ControlId.AddRelationships ||
                                res.ctrl.controlID === ControlId.AddNewPosition ||
                                res.ctrl.controlID === ControlId.JobTitle ||
                                res.ctrl.controlID === ControlId.Alias ||
                                res.ctrl.controlID === ControlId.JobFunction ||
                                res.ctrl.controlID.indexOf(ControlId.AddRelationshipEntity) > -1
                            ))
                            .subscribe(res => this.watchControlValueChange(res)));
                    // start to get valid relationship type for dialog
                    this._store.dispatch({
                        type: RelationshipTypeActionTypes.GETVALIDRELATIONSHIP
                    });
                    this._contactViewModel.templateValueSet(this.dialogOpenOptions.instanceId).subscribe((res) =>
                        this._processConfigValue(res));

                    if (dialogOpenOptions.contact && dialogOpenOptions.openType === ContactTemplateType.EditContact) {
                        this.currentContact = _lodash.cloneDeep(dialogOpenOptions.contact);
                        this.currentContactRelationshipAndEmployment = this._convertRelationshipForEdit(this.currentContact.relationships);
                        this._dialogCloseDestroySubscriptions.push(
                            this._contactTemplateService.actionSubject$.subscribe(action => {
                                if (action.type === CompanyAction.ChangeCompany) {
                                    this._moveCurrentEmploymentToFormerEmployment(action.payload.originalCompany, action.payload.targetCompany);
                                } else if (action.type === CompanyAction.CreateValidCompany) {
                                    this._createCurrentEmployment(action.payload.originalCompany, action.payload.targetCompany);
                                    this._moveCurrentEmploymentToFormerEmployment(action.payload.originalCompany, action.payload.targetCompany);
                                } else if (action.type === CompanyAction.CreateInvalidCompany) {
                                    this._createCurrentEmployment(action.payload.originalCompany, action.payload.targetCompany);
                                    this._saveCurrentEmployment(action.payload.targetCompany);
                                }
                            }),
                        );
                        this._initContact();
                    } else if (dialogOpenOptions.openType === ContactTemplateType.NewContact) {
                        this._initContact();
                        this._dialogCloseDestroySubscriptions.push(
                            this._contactTemplateService.actionSubject$.subscribe(action => {
                                if (action.type === EmailAction.ChangeEmailValue && action.payload && action.payload.prefix === dialogOpenOptions.instanceId) {
                                    this._detectDuplicatedEmail(action.payload);
                                }
                            }),
                        );
                    }
                    this._dialogCloseDestroySubscriptions.push(
                        this._contactViewModel.getContactEamilCount(this.dialogOpenOptions.instanceId).subscribe(res => this._contactEmailGroupIds = res),
                        fromEvent(window, 'mousewheel').pipe(
                            debounceTime(250)
                        ).subscribe((e: any) => {
                            if (this._el.querySelector('.tml-tpl-wrap')) {
                                const selectedLabel = this._dialogLabelArray.filter(item => item.top >= this._el.querySelector('.tml-tpl-wrap').scrollTop)[0];
                                if (selectedLabel) {
                                    this._contactTemplateService.actionSubject$.next({
                                        type: NavigationAction.ChangeNavigationSection,
                                        payload: {
                                            name: selectedLabel.label,
                                            instanceId: this.dialogOpenOptions.instanceId
                                        }
                                    });
                                }
                            }
                        }),
                    );
                }
            }),

            this._contactTemplateService.actionSubject$.subscribe(action => {
                // for relationship action
                if ((action.type === RelationshipAction.ChangeRelationshipEntity ||
                    action.type === RelationshipAction.ChangeRelationshipType) && !this._isRelationshipControlValueChanged) {
                    this._isRelationshipControlValueChanged = true;
                }
                // for change job title action
                if (this.dialogOpenOptions && action.type === JobTitleAction.ChangeJobTitle && action.prefixId === this.dialogOpenOptions.instanceId) {
                    this._handleEmploymentJobtitle(action.payload);
                }
                // for navigation action
                if (action.type === NavigationAction.ChangeDialogSection) {
                    this._changeDialogSection(action.payload);
                }
                // for dialog close
                if (action.type === DialogAction.CloseDialog && action.payload.instanceId === this.id) {
                    this.opened = false;
                    this._clearData();
                }
            }),

        );
    }

    ngAfterViewInit() { }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        this._destroySubscriptions = [];
        this.currentContact = null;
    }

    onContainerEvent(event) {
        this.viewContainer = event;
    }

    /**
     * Load the section and each control over the array
     */
    processingData(config) {
        return Array.from(this._setConfig(config));
    }

    processingAction() {
        switch (this._action) {
            case ContactActions.createContact:
                break;
            case ContactActions.editContact:
                break;
        }
    }

    private _changeDialogSection(config) {
        if (config && this.dialogOpenOptions && config.instanceId === this.dialogOpenOptions.instanceId) {
            const scrollTopValue = this._dialogLabelArray.filter(item => item.label === config.name)[0].top;
            this._el.querySelector('.tml-tpl-wrap').scrollTop = scrollTopValue;
        }
    }

    /**
    * click the  minimize button .appear the minimize window
    */
    public windowMinimize() {
        this._renderer.setStyle(this._el.querySelector('.minimize-interface'), 'visibility', 'visible');
        // this.isShow = true;
        this._renderer.setStyle(this._el.querySelector('.template-dialog'), 'visibility', 'hidden');
        this._contactTemplateService.minimized = true;
    }

    /**
     * dialog maxmize
     */
    public maxmize() {
        this._renderer.setStyle(this._el.querySelector('.minimize-interface'), 'visibility', 'hidden');
        this._renderer.setStyle(this._el.querySelector('.template-dialog'), 'visibility', 'visible');
        this._contactTemplateService.minimized = false;
    }

    /**
     * close dialog min
     */
    public closemin() {
        this.maxmize();
        this.clickClose();
    }

    public onEnter(value) {
        if (this.opened) {
            this.clickClose();
        }
    }

    public onCancelBtnClick(event: Event) {
        this.clickClose();
    }

    public clickClose() {
        if (!this._contactTemplateService.changeValueStatus) {
            this.opened = false;
            this._clearData();
        } else {
            const subscription = this._alertWindow.warn('You have unsaved changes', ['Are you sure you want to discard all your changes?'], 'Discard', 'Go Back', this.dialogOpenOptions.eventKey, this.dialogOpenOptions.eventValue)
                .subscribe((result: boolean) => {
                    if (result) {
                        this.opened = false;
                        for (let i = 0; i < this._addedFormerEmploymentCtrlGroupId.length; i++) {
                            this._deleteNewAddedControl(this._addedFormerEmploymentCtrlGroupId[i], 'Position');
                        }
                        this._clearData();
                    }
                    subscription.unsubscribe();
                });
        }
        this._openDynamicComponentService.feedbackSubject$.next(DialogAction.CloseDialog);
    }

    createContact() {
        if (this.dialogOpenOptions.openType === ContactTemplateType.NewContact) {
            this._contactViewModel.createContact(this.currentContact, this.dialogOpenOptions.instanceId);
            this._contactViewModel.setContactStatusCreate();
        } else if (this.dialogOpenOptions.openType === ContactTemplateType.EditContact) {
            this._contactViewModel.setContactStatusEdit();
            // only relationship control value changed, will send the request to server for update
            if (this._isRelationshipControlValueChanged) {
                this._deleteMultiContactRelationshipType();
                this._createMultiContactRelationshipType();
            }
            this._contactViewModel.editContact(this.currentContact, this.dialogOpenOptions.instanceId);
        }
    }

    createValidRelationshipRequest(id) {
        return this._contactRelationshipService.createValidRelationship(this._contactToEntities, id)
            .pipe(
                catchError((err) => {
                    return of(null);
                }));
    }

    /**
     * create relationship by restapi
     * 1.check is exist relationship type
     * 2.create no exist realtionship type
     * 3.create all invalid relationship
     */
    createRelationship() {
        this._store.pipe(
            select(contactNewAddedJobTitleSelector),
            take(1),
        ).subscribe(jobTitle => {
            let existRelationshipType = [];
            // to add this filter, so that we don't need to create this job title
            if (jobTitle && jobTitle.length > 0) {
                jobTitle = jobTitle.filter(element => element.count > 0);
            } else {
                jobTitle = [];
            }

            if (jobTitle.length === 0) {
                this.createContact();
            } else {
                const nameArray = jobTitle.map(item => item.name);
                this._contactRelationshipService.getValidRelationshipByName(nameArray).pipe(
                    catchError((err) => {
                        return of(null);
                    }),
                ).subscribe(res => {
                    existRelationshipType = res['exist'];
                    const noExist = res['not-exist'];
                    const newCreatedRelationshipTypeArray = []; // this var is to create this relationship type
                    const newCreatedValidRelationshipTypeArray = []; // this var is to change the new created relationship type to valid relationship type
                    noExist.forEach(item => {
                        newCreatedRelationshipTypeArray.push(
                            this._contactRelationshipService.createRelationshipType(item['name']));
                    });

                    let observable: Observable<any>;
                    if (newCreatedRelationshipTypeArray.length === 0) {
                        observable = new Observable(subscriber => {
                            subscriber.next(undefined);
                            subscriber.complete();
                        });
                    } else {
                        observable = forkJoin(newCreatedRelationshipTypeArray);
                    }
                    observable.subscribe(response => {
                        if (response && response.length > 0) {
                            response.forEach(res1 => {
                                if (res1) {
                                    newCreatedValidRelationshipTypeArray.push(this.createValidRelationshipRequest(res1['id']));
                                }
                            });
                        }
                        if (existRelationshipType.length > 0) {
                            existRelationshipType.forEach(item => {
                                newCreatedValidRelationshipTypeArray.push(this.createValidRelationshipRequest(item.ID));
                            });
                        }
                        if (newCreatedValidRelationshipTypeArray.length > 0) {
                            // the new created valid relationship may be the job title value, or employment value, or relationship value
                            forkJoin(newCreatedValidRelationshipTypeArray).subscribe(item => {
                                // now, for the current job title: only have the id value, including the fake id
                                // for the jobTitle in store, it will have the name and id(including the fake id)
                                // for the res, it will have the name and real id
                                // so, we need to get a mapping array
                                // new array: {original id, new id, name}
                                const mappingArray = [];
                                if (item && item.length > 0 && jobTitle && jobTitle.length > 0) {
                                    item.forEach(items => {
                                        jobTitle.forEach(element => {
                                            if (items['name'] === element.name) {
                                                mappingArray.push({
                                                    originalId: element.id,
                                                    newCreatedId: items['id'],
                                                    name: element.name
                                                });
                                            }
                                        });
                                    });
                                }

                                // here we need to adjust if the new added relationship type belongs to which part： only the mapping array length > 0
                                if (mappingArray.length > 0) {
                                    // first, we adjust if it belongs to job title control
                                    if (this.currentContact.jobTitle && this.currentContact.jobTitle.length > 0 && this.currentContact.jobTitle.filter(ele => ele.indexOf('fakeId') > -1).length > 0) {
                                        // it is that the job title control has the new added rel-type
                                        this.currentContact.jobTitle.forEach((element, index) => {
                                            if (element.indexOf('fakeId') > -1) {
                                                this.currentContact.jobTitle[index] = mappingArray.find(item1 => item1.originalId === element).newCreatedId;
                                            }
                                        });
                                    }

                                    // second, we adjust if it belongs to former employment part
                                    this.currentContact.employment.forEach((element, index) => {
                                        if (element.titleType[0].indexOf('fakeId') > -1) {
                                            this.currentContact.employment[index].titleType[0] = mappingArray.find(item2 => item2.originalId === element.titleType[0]).newCreatedId;
                                        }
                                    });

                                    // third, we adjust if it belongs to relationship part
                                    this.currentContact.relationship.forEach((element, index) => {
                                        if (element.relationshipType.indexOf('fakeId') > -1) {
                                            this.currentContact.relationship[index].relationshipType = mappingArray.find(item3 => item3.originalId === element.relationshipType).newCreatedId;
                                        }
                                    });
                                }
                                this.createContact();
                            });
                        } else {
                            this.createContact();
                        }
                    });
                });
            }
        });
    }

    keySend(event) {
        if (event.ctrlKey && event.keyCode === 13) {
            this.publish();
        }
    }

    publish() {
        this._processDataBeforeSave();
        if (this._verifyInput()) {
            this.createRelationship();
        }
    }

    onClickSetEventValue(e: Event) {
        if (this.dialogOpenOptions) {
            e[this.dialogOpenOptions.eventKey] = this.dialogOpenOptions.eventValue;
        }
    }

    viewDuplicated() {
        // need to make sure the view duplicate dialog has the same instanceId with the contact dialog
        // because will close it together
        // and then if have more than one contact dialog, will know which contact dialog will close
        this._duplicatedContactDialogService.dialogOpen$.next({
            type: DialogAction.OpenDialog,
            payload: this._duplicatedContactInfo
        });
    }

    watchControlValueChange(res: any) {
        const _config = _lodash.cloneDeep(this.tplConfig);
        switch (res.ctrl.controlID) {
            case 'AddPhoneNumber':
                _config.layout.forEach((item, i) => {
                    if (item.controlID === 'AddPhoneNumber') {
                        this.tplConfig.layout.splice(i, 0, res.value[0]);
                        this.tplConfig.layout.splice(i + 1, 0, res.value[1]);
                        this.tplConfig.layout.splice(i + 2, 0, res.value[2]);
                        this._addBackControlTopValue(i + 3, 50);
                        return;
                    }
                });
                break;
            case 'AddEmail':
                _config.layout.forEach((item, i) => {
                    if (item.controlID === 'AddEmail') {
                        this.tplConfig.layout.splice(i, 0, res.value[0]);
                        this.tplConfig.layout.splice(i + 1, 0, res.value[1]);
                        this.tplConfig.layout.splice(i + 2, 0, res.value[2]);
                        this._addBackControlTopValue(i + 3, 50);
                        return;
                    }
                });
                break;
            case 'AddAddress':
                _config.layout.forEach((item, i) => {
                    if (item.controlID === 'AddAddress') {
                        this.tplConfig.layout.splice(i, 0, res.value[0]);
                        this.tplConfig.layout.splice(i + 1, 0, res.value[1]);
                        this.tplConfig.layout.splice(i + 2, 0, res.value[2]);
                        this.tplConfig.layout.splice(i + 3, 0, res.value[3]);
                        this.tplConfig.layout.splice(i + 4, 0, res.value[4]);
                        this.tplConfig.layout.splice(i + 5, 0, res.value[5]);
                        this.tplConfig.layout.splice(i + 6, 0, res.value[6]);
                        this.tplConfig.layout.splice(i + 7, 0, res.value[7]);
                        this._addBackControlTopValue(i + 8, 166);
                        return;
                    }
                });
                break;

            case 'trash':
                let deleteIndex;
                if (res.ctrl.trashType === 'Email' && !res.ctrl.clickRemove) {
                    return;
                }
                this.tplConfig.layout.forEach((item, index) => {
                    if (item.trashId === res.value) {
                        deleteIndex = index;
                    }
                });
                // when click the trash btn, we need to remove the item from store, or the item will be saved
                for (const value in this._contactTemplateValueSet) {
                    if (value.indexOf(res.value) !== -1) {
                        const positionCondition = res.ctrl.trashType === 'Position' && this._contactTemplateValueSet[value].ctrl.controlID.indexOf(ControlId.Former_Employment_JobTitle) > -1;
                        const relationshipCondition = res.ctrl.trashType === 'Relationship' && this._contactTemplateValueSet[value].ctrl.controlID.indexOf(ControlId.AddRelationshipType) > -1;
                        if ((positionCondition || relationshipCondition) && this._contactTemplateValueSet[value].value.indexOf('fakeId') > -1) {
                            this._store.dispatch({
                                type: REMOVE_JOB_TITLE,
                                payload: {
                                    name: this._contactTemplateValueSet[value].displayValue,
                                    id: this._contactTemplateValueSet[value].value,
                                }
                            });
                        }
                        delete this._contactTemplateValueSet[value];
                    }
                }
                this.tplConfig.layout = this.tplConfig.layout.filter(item => {
                    return item.trashId !== res.value;
                });

                if (res.ctrl.trashType === 'Relationship') {
                    this._isRelationshipControlValueChanged = true;
                }
                if (res.ctrl.trashType === 'Address') {
                    this._addBackControlTopValue(deleteIndex - 7, -166);
                } else if (res.ctrl.trashType === 'Position') {
                    this._addBackControlTopValue(deleteIndex - 4, -116);
                } else {
                    this._addBackControlTopValue(deleteIndex - 2, -50);
                }
                if (res.ctrl.trashType === 'Email') {
                    if (res.ctrl.isPrimary && res.ctrl.clickRemove) {
                        const index = this._contactEmailGroupIds.findIndex(item => item === res.ctrl.trashId);
                        let primaryId = '';
                        if (index < this._contactEmailGroupIds.length - 1 && this._contactEmailGroupIds.length !== 1) {
                            primaryId = this._contactEmailGroupIds[index + 1];
                        } else {
                            primaryId = 'work';
                        }
                        res.ctrl['isPrimary'] = true;
                        res.ctrl['primaryId'] = primaryId;
                        this._contactTemplateService.actionSubject$.next({
                            type: ControlId.Trash,
                            payload: primaryId
                        });
                    }
                    if (this._contactEmailGroupIds.length > 0) {
                        this._contactViewModel.decrement(res.ctrl.trashId, this.dialogOpenOptions.instanceId);
                    }
                }
                break;

            case 'AddInternetInfo':
                _config.layout.forEach((item, i) => {
                    if (item.controlID === 'AddInternetInfo') {
                        this.tplConfig.layout.splice(i, 0, res.value[0]);
                        this.tplConfig.layout.splice(i + 1, 0, res.value[1]);
                        this.tplConfig.layout.splice(i + 2, 0, res.value[2]);
                        this._addBackControlTopValue(i + 3, 50);
                        return;
                    }
                });
                break;
            case ControlId.AddRelationships:
                _config.layout.forEach((item, i) => {
                    if (item.controlID === ControlId.AddRelationships) {
                        this.tplConfig.layout.splice(i, 0, res.value[0]);
                        this.tplConfig.layout.splice(i + 1, 0, res.value[1]);
                        this.tplConfig.layout.splice(i + 2, 0, res.value[2]);
                        this._addBackControlTopValue(i + 3, 50);
                        return;
                    }
                });
                break;
            case ControlId.AddNewPosition:
                _config.layout.forEach((item, i) => {
                    if (item.controlID === ControlId.AddNewPosition) {
                        this.tplConfig.layout.splice(i + 1, 0, res.value[0]);
                        this.tplConfig.layout.splice(i + 2, 0, res.value[1]);
                        this.tplConfig.layout.splice(i + 3, 0, res.value[2]);
                        this.tplConfig.layout.splice(i + 4, 0, res.value[3]);
                        this.tplConfig.layout.splice(i + 5, 0, res.value[4]);
                        this._addBackControlTopValue(i + 6, 116);
                        return;
                    }
                });
                break;
            case ControlId.JobTitle:
                if (res.ctrl.paddingInput) {
                    _config.layout.forEach((item, i) => {
                        if (item.controlID === ControlId.JobTitle) {
                            this._addBackControlTopValue(i + 1, res.ctrl.paddingInput);
                            return;
                        }
                    });
                    res.ctrl.paddingInput = 0;
                }
                break;
        }
        if (res.ctrl.controlID.indexOf(ControlId.AddRelationshipEntity) > -1) {
            if (res.ctrl.paddingInput) {
                _config.layout.forEach((item, i) => {
                    if (item.controlID === res.ctrl.controlID) {
                        this._addBackControlTopValue(i + 1, res.ctrl.paddingInput);
                        return;
                    }
                });
                res.ctrl.paddingInput = 0;
            }
        } else if (res.ctrl.controlID === ControlId.JobFunction) {
            if (res.ctrl.paddingInput) {
                _config.layout.forEach((item, i) => {
                    if (item.controlID === ControlId.JobFunction) {
                        this._addBackControlTopValue(i + 1, res.ctrl.paddingInput);
                        return;
                    }
                });
                res.ctrl.paddingInput = 0;
            }
        } else if (res.ctrl.controlID === ControlId.Alias) {
            if (res.ctrl.paddingInput) {
                _config.layout.forEach((item, i) => {
                    if (item.controlID === ControlId.Alias) {
                        this._addBackControlTopValue(i + 1, res.ctrl.paddingInput);
                        return;
                    }
                });
                res.ctrl.paddingInput = 0;
            }
        }
        this._dialogLabelArray = this.tplConfig.layout.filter(item => item.componentType === 'label');
    }

    private _createCurrentEmployment(originalCompany, targetCompany) {
        // tslint:disable-next-line: forin
        for (const index in this._contactTemplateValueSet) {
            const ctrl = this._contactTemplateValueSet[index];
            if (ctrl.ctrl.controlID === 'JobTitle') {
                const jobTitleIdArray = ctrl.value.split(',');
                const jobTitleNameArray = ctrl.displayValue.split(',');
                const currentEmployment = [];
                for (let i = 0; i < jobTitleIdArray.length; i++) {
                    currentEmployment.push({
                        id: jobTitleIdArray[i],
                        value: jobTitleNameArray[i],
                        startYear: 0,
                        isEdit: true
                    });
                }
                this._handleEmploymentJobtitle(currentEmployment);
                break;
            }
        }
    }

    private _convertRelationshipForEdit(relationships) {
        // to save 5 values: relationship id, child entity id, realtionship type name, relationship id, child entity name
        const _relationships = []; // [{{relationshiptype}: [{entities}]},{{relationshiptype}: [{entities}]}]
        const _currentEmployment = [];
        const _formerEmployment = [];
        relationships.forEach(element => {
            if (!element.nodesType && !element.startYear && !element.endYear) {
                let _index = 0;
                let _nodeType = '';
                let _isNodeEditable = true;
                if (element.relationshipType.id === RelationshipType.IS_IN_TEAM.id) {
                    _nodeType = RelationshipType.IS_IN_TEAM.name;
                    if (this._currentUser.credential.manageTeam) {
                        _isNodeEditable = true;
                    } else {
                        _isNodeEditable = false;
                    }
                } else if (element.relationshipType.id === RelationshipType.TOPIC_MEMBER.id) {
                    _nodeType = RelationshipType.TOPIC_MEMBER.name;
                    if (this._currentUser.credential.manageTeam) {
                        _isNodeEditable = true;
                    } else {
                        _isNodeEditable = false;
                    }
                } else {
                    if (element.childEntity.type.id === EntityType.CONTACT.id &&
                        element.parentEntity.type.id === EntityType.CONTACT.id) {
                        _nodeType = ContactRelationshipType.Contact;
                    } else {
                        _nodeType = ContactRelationshipType.ContactAll;
                    }
                }
                // to get the relationships array: [{{relationshiptype}: [{entities}]},{{relationshiptype}: [{entities}]}]
                if (_relationships.some((item, index, _tempArray) => {
                    _index = index;
                    return item.relationshipType.relationshipTypeId === element.relationshipType.id;
                })) {
                    // has existed the relationship type
                    // just need to get the first entity's isEditable
                    _relationships[_index].relationshipEntities.push({
                        relationshipId: element.relationshipId,
                        childEntityName: element.childEntity.name,
                        childEntityId: element.childEntity.id,
                        nodeType: _nodeType,
                    });
                } else {
                    // new added relationship type
                    const _tempRelationshipTypeArray = {
                        relationshipTypeId: element.relationshipType.id,
                        relationshipTypeName: element.relationshipType.name,
                        isNodeEditable: _isNodeEditable,
                    };
                    const _tempRelationshipEntitiesArray = [{
                        relationshipId: element.relationshipId,
                        childEntityName: element.childEntity.name,
                        childEntityId: element.childEntity.id,
                        nodeType: _nodeType,
                        isNodeEditable: _isNodeEditable,
                    }];
                    _relationships.push({
                        relationshipType: _tempRelationshipTypeArray,
                        relationshipEntities: _tempRelationshipEntitiesArray
                    });
                }
            } else if (element.nodesType === 'currentEmployment') {
                _currentEmployment.push({
                    relationshipId: element.relationshipId,
                    childEntityName: element.childEntity.name,
                    childEntityId: element.childEntity.id,
                    relationshipTypeId: element.relationshipType.id,
                    relationshipTypeName: element.relationshipType.name,
                    startYear: this._parseTimeToStandardTime(element.startYear)
                });
            } else if (element.nodesType === 'formerEmployment') {
                _formerEmployment.push({
                    relationshipId: element.relationshipId,
                    childEntityName: element.childEntity.name,
                    childEntityId: element.childEntity.id,
                    relationshipTypeId: element.relationshipType.id,
                    relationshipTypeName: element.relationshipType.name,
                    startYear: this._parseTimeToStandardTime(element.startYear),
                    endYear: this._parseTimeToStandardTime(element.endYear)
                });
            }
        });
        ArrayHelperService.sort(_formerEmployment, 'endYear');
        return {
            relationships: _relationships,
            currentEmployment: _currentEmployment,
            formerEmployment: _formerEmployment
        };
    }

    private _setStaticDefaultValueForEdit(config: any) {
        let primaryEmail = null;
        this._currentRelationshipArray = [];
        this.currentContactRelationshipAndEmployment.relationships.forEach(item => {
            this._currentRelationshipArray.push(item.relationshipType.relationshipTypeId);
        });
        if (this.currentContact && this.currentContact.webAddress != null && this.currentContact.webAddress.length > 0) {
            const webAddress = this.currentContact.webAddress;
            for (const object of webAddress) {
                if (object.name === 'Work') {
                    primaryEmail = object;
                }
            }
        }
        let signPhoneIndex = 0;
        let signEmailIndex = 0;
        let signAddressIndex = 0;
        let signInternetIndex = 0;
        let signRelationshipIndex = 0;
        let signCurrentEmploymentIndex = 0;
        let signFormerEmploymentIndex = 0;
        for (const ctrl of config.layout) {
            ctrl['openAction'] = this.dialogOpenOptions.openType;
            ctrl['prefixId'] = this.dialogOpenOptions.instanceId;
            if (ctrl.controlID === 'FirstName') {
                ctrl.staticDefaultValue = this.currentContact.firstName;
            } else if (ctrl.controlID === 'LastName') {
                ctrl.staticDefaultValue = this.currentContact.lastName;
            } else if (ctrl.controlID === 'Alias') {
                ctrl.staticDefaultValue = this.currentContact.aliases;
                ctrl.newHeight = this.currentContact.template.aliasHeight;
            } else if (ctrl.controlID === 'Company') {
                ctrl.staticDefaultValue = this.currentContact.companyWeb['id'] || '';
                ctrl['companyName'] = this.currentContact.companyWeb['short-name'] || '';
            } else if (ctrl.controlID === 'Birthday' && this.currentContact.birthday !== '') {
                ctrl.staticDefaultValue = new Date(this.currentContact.birthday);
            } else if (ctrl.controlID === 'JobTitle') {
                ctrl.staticDefaultValue = this.currentContact.jobTitleWeb;
                ctrl.newHeight = this.currentContact.template.jobTitleHeight;
            } else if (ctrl.controlID === 'JobFunction') {
                ctrl.staticDefaultValue = this.currentContact.jobFunction.map(data => data.name);
                ctrl.newHeight = this.currentContact.template.jobFunctionHeight;
            } else if (ctrl.controlID === 'Notes') {
                ctrl.staticDefaultValue = this.currentContact.notes;
            } else if (ctrl.controlID === 'WorkEmailValue') {
                ctrl.staticDefaultValue = this.currentContact.primaryEmail;
            } else if (ctrl.controlID === 'PhoneInput') {
                if (this.currentContact.webPhone != null && this.currentContact.webPhone.length > 0) {
                    const phones = this.currentContact.webPhone;
                    ctrl.staticDefaultValue = phones[0];
                    for (const object of phones) {
                        if (object.name === 'Work') {
                            ctrl.staticDefaultValue = object.phone;
                        }
                    }
                }
            }
        }

        for (const ctrl of config.layout) {
            // get phone default value
            if (signPhoneIndex < this.currentContact.webPhone.length && ctrl.controlID) {
                if (ctrl.controlID.toLowerCase().indexOf('phone') !== -1 && ctrl.componentType === 'singleDropdown') {
                    ctrl.staticDefaultValue = this.currentContact.webPhone[signPhoneIndex].name;
                }
                if (ctrl.controlID.toLowerCase().indexOf('phone') !== -1 && ctrl.componentType === 'input') {
                    ctrl.staticDefaultValue = this.currentContact.webPhone[signPhoneIndex].phone;
                    signPhoneIndex++;
                }
            }
            // get email default value
            if (signEmailIndex < this.currentContact.webEmail.length && ctrl.controlID) {
                if (ctrl.controlID.toLowerCase().indexOf('email') !== -1 && ctrl.componentType === 'singleDropdown') {
                    ctrl.staticDefaultValue = this.currentContact.webEmail[signEmailIndex].name;
                }
                if (ctrl.controlID.toLowerCase().indexOf('email') !== -1 && ctrl.componentType === 'input') {
                    ctrl.staticDefaultValue = this.currentContact.webEmail[signEmailIndex].address || '';
                    ctrl.primaryEmail = this.currentContact.webEmail[signEmailIndex].primaryEmail;
                    signEmailIndex++;
                }
            }
            // get address default value
            if (signAddressIndex < this.currentContact.webAddress.length && ctrl.controlID) {
                if (ctrl.controlID.toLowerCase().indexOf('address') !== -1 && ctrl.componentType === 'singleDropdown') {
                    ctrl.staticDefaultValue = this.convertAddress(this.currentContact.webAddress[signAddressIndex].name);
                } else if (ctrl.controlID.toLowerCase().indexOf('country') !== -1) {
                    ctrl.staticDefaultValue = this.convertAddress(this.currentContact.webAddress[signAddressIndex].country);
                    ctrl['street1'] = this.currentContact.webAddress[signAddressIndex].street || '';
                } else if (ctrl.controlID.toLowerCase().indexOf('street1') !== -1) {
                    if (!this.currentContact.webAddress[signAddressIndex].country && !this.currentContact.webAddress[signAddressIndex].state
                        && this.currentContact.webAddress[signAddressIndex].originalAddress) {
                        ctrl.staticDefaultValue = this.currentContact.webAddress[signAddressIndex].originalAddress;
                    } else {
                        ctrl.staticDefaultValue = this.currentContact.webAddress[signAddressIndex].street || '';
                    }
                } else if (ctrl.controlID.toLowerCase().indexOf('street2') !== -1) {
                    ctrl.staticDefaultValue = this.currentContact.webAddress[signAddressIndex].street2 || '';
                } else if (ctrl.controlID.toLowerCase().indexOf('city') !== -1) {
                    ctrl.staticDefaultValue = this.currentContact.webAddress[signAddressIndex].city || '';
                } else if (ctrl.controlID.toLowerCase().indexOf('state') !== -1) {
                    ctrl.staticDefaultValue = this.currentContact.webAddress[signAddressIndex].state || '';
                    ctrl['street1'] = this.currentContact.webAddress[signAddressIndex].street || '';
                } else if (ctrl.controlID.toLowerCase().indexOf('zip') !== -1) {
                    ctrl.staticDefaultValue = this.currentContact.webAddress[signAddressIndex].zip || '';
                    signAddressIndex++;
                }
            }
            // get current employment default value
            if (signCurrentEmploymentIndex < this.currentContactRelationshipAndEmployment.currentEmployment.length && ctrl.controlID) {
                if (ctrl.controlID.indexOf(ControlId.Current_Employment_JobTitle) !== -1 && ctrl.componentType === 'input') {
                    ctrl.staticDefaultValue = this.currentContactRelationshipAndEmployment.currentEmployment[signCurrentEmploymentIndex];
                }
                if (ctrl.controlID.indexOf(ControlId.Current_Employment_StartYear) !== -1 && ctrl.componentType === 'dropdown') {
                    ctrl.staticDefaultValue = this.currentContactRelationshipAndEmployment.currentEmployment[signCurrentEmploymentIndex].startYear;
                    signCurrentEmploymentIndex++;
                }
            }
            // get former employment default value
            if (signFormerEmploymentIndex < this.currentContactRelationshipAndEmployment.formerEmployment.length && ctrl.controlID) {
                if (ctrl.controlID.indexOf(ControlId.Former_Employment_JobTitle) !== -1 && ctrl.componentType === 'dropdown') {
                    ctrl.staticDefaultValue = this.currentContactRelationshipAndEmployment.formerEmployment[signFormerEmploymentIndex].relationshipTypeId;
                }
                if (ctrl.controlID.indexOf(ControlId.Former_Employment_Company) !== -1 && ctrl.componentType === 'dropdown') {
                    ctrl.staticDefaultValue = this.currentContactRelationshipAndEmployment.formerEmployment[signFormerEmploymentIndex].childEntityId;
                }
                if (ctrl.controlID.indexOf(ControlId.Former_Employment_StartYear) !== -1 && ctrl.componentType === 'dropdown') {
                    ctrl.staticDefaultValue = this.currentContactRelationshipAndEmployment.formerEmployment[signFormerEmploymentIndex].startYear;
                }
                if (ctrl.controlID.indexOf(ControlId.Former_Employment_EndYear) !== -1 && ctrl.componentType === 'dropdown') {
                    ctrl.staticDefaultValue = this.currentContactRelationshipAndEmployment.formerEmployment[signFormerEmploymentIndex].endYear;
                    signFormerEmploymentIndex++;
                }
            }
            // get relationships default value
            if (signRelationshipIndex < this.currentContactRelationshipAndEmployment.relationships.length && ctrl.controlID) {
                if (ctrl.controlID.indexOf(ControlId.AddRelationshipType) !== -1 && ctrl.componentType === 'dropdown') {
                    ctrl.staticDefaultValue = this.currentContactRelationshipAndEmployment.relationships[signRelationshipIndex].relationshipType;
                }
                if (ctrl.controlID.indexOf(ControlId.AddRelationshipEntity) !== -1 && ctrl.componentType === 'med') {
                    ctrl.staticDefaultValue = this.currentContactRelationshipAndEmployment.relationships[signRelationshipIndex].relationshipEntities;
                    signRelationshipIndex++;
                }
            }

            // get Internet default value
            if (signInternetIndex < this.currentContact.socialMedia.length && ctrl.controlID) {
                if (ctrl.controlID.toLowerCase().indexOf('internet') !== -1 && ctrl.componentType === 'singleDropdown') {
                    ctrl.staticDefaultValue = this.currentContact.socialMedia[signInternetIndex].name;
                }
                if (ctrl.controlID.toLowerCase().indexOf('internet') !== -1 && ctrl.componentType === 'input') {
                    ctrl.staticDefaultValue = this.currentContact.socialMedia[signInternetIndex].link;
                    signInternetIndex++;
                }
            }
        }
        // return config;
    }

    private convertAddress(content) {
        if (!content) {
            return '';
        } else {
            return content;
        }
    }

    private _addBackControlTopValue(index, padding) {
        for (let i = index; i < this.tplConfig.layout.length; i++) {
            this.tplConfig.layout[i].top = parseInt(this.tplConfig.layout[i].top, 0) + padding;
        }
    }

    private _clearData() {
        if (this.dialogOpenOptions && this.dialogOpenOptions.openType === ContactTemplateType.NewContact) {
            this._homeViewModel.decrement();
        }
        this.currentContact = null;
        this._contactTemplateValueSet = null;
        this._relationshipTypes = null;
        this.tplConfig = null;
        this._contactTemplateService.changeValueStatus = false;
        this._contactViewModel.cleanTemplateValueSet(this.dialogOpenOptions.instanceId);
        this._contactViewModel.cleanTemplateMsg(this.dialogOpenOptions.instanceId);
        this._contactViewModel.reset(this.dialogOpenOptions.instanceId);
        this._dialogCloseDestroySubscriptions.forEach(item => item.unsubscribe());
        this._dialogCloseDestroySubscriptions = [];
        this._duplicatedContactInfo = [];
        this.isDuplicatedContact = false;
        this.dialogOpenOptions = null;
        this.valueChangeSubject = null;
        // if close the dialog, we need to clear the store data
        this._store.dispatch({
            type: CLEAR_JOB_TITLE
        });
    }

    private _actionMessageHandler(action) {
        if (!action.prefix) {
            action.prefix = '';
        }
        if (this.dialogOpenOptions && action.prefix === this.dialogOpenOptions.instanceId) {
            if (action.type === CREATE_CONTACT_SUCCESS) {
                const contact = action.payload;
                if (this.dialogOpenOptions && this.dialogOpenOptions.entityBack) {
                    this._feedBackToPrivousDialog(contact);
                }
                this._clearData();
                this.opened = false;
                const successMessage = 'Contact ' + action.payload.name + ' successfully created.';
                const _successToast: NotificationOptions = {
                    message: successMessage,
                    style: NotificationStyles.Success
                };
                this._toast.notify(_successToast);
                this._openDynamicComponentService.feedbackSubject$.next(DialogAction.CloseDialog);
            } else if (action.type === EDIT_CONTACT_SUCCESS) {
                const successMessage = 'Contact ' + action.payload.name + ' successfully updated.';
                const _successToast: NotificationOptions = {
                    message: successMessage,
                    style: NotificationStyles.Success
                };
                this._clearData();
                this.opened = false;
                this._toast.notify(_successToast);
            }
        }
    }

    private _createContactRelationType(action) {
        if (this._relationshipTypes && this._relationshipTypes.length > 0) {
            const addEntityObj = {};
            const childEntity: Array<string> = [];
            const content = this._relationshipTypes.split(',');
            for (const item of content) {
                childEntity.push(this.currentContact.companyWeb);
            }
            addEntityObj['relType'] = this._relationshipTypes;
            addEntityObj['parentEntity'] = action.payload.id;
            addEntityObj['childEntity'] = childEntity.join(';');
            addEntityObj['isCreateReciprocal'] = true;
            addEntityObj['isAppend'] = true;

            this._relationshipService.createMultipleRelationship(addEntityObj).pipe(
                catchError((err) => {
                    this._clearData();
                    return of(null);
                })
            ).subscribe(data => {
                this._clearData();
            });
        }
    }

    private _createMultiContactRelationshipType() {
        // for this function, we need to divide to three parts:
        // the entities and the topic member and the is in team
        // so, first, we need to get the create common entities request vars
        // then, we need to get the is in team request vars if the is in team exists
        // and get the topic member vars if the topic member exists
        const relationshipTypesArray = this.currentContact.relationship.map(item => item.relationshipType);
        const entitiesArray = this.currentContact.relationship.map(item => item.childEntity.map(element => element).join(','));
        const isInTeamLocation = relationshipTypesArray.indexOf(RelationshipType.IS_IN_TEAM.id);
        const topicMemberLocation = relationshipTypesArray.indexOf(RelationshipType.TOPIC_MEMBER.id);
        const addEntityObj = {};
        const isInteamOrTopicMemberObj = {
            childEntity: this.currentContact.id,
            parentEntity: {},
        };

        // for is in team
        if (isInTeamLocation > -1) {
            const isInTeamParentArray = [];
            entitiesArray[isInTeamLocation].split(',').forEach(element => {
                isInTeamParentArray.push(element);
            });
            isInteamOrTopicMemberObj.parentEntity[businessConstants.RelationshipTypes.IS_IN_TEAM_ID] = isInTeamParentArray;
            relationshipTypesArray.splice(isInTeamLocation, 1);
            entitiesArray.splice(isInTeamLocation, 1);
        }
        // for topic member
        if (topicMemberLocation > -1) {
            const topicMemberParentArray = [];
            entitiesArray[topicMemberLocation].split(',').forEach(element => {
                topicMemberParentArray.push(element);
            });
            isInteamOrTopicMemberObj.parentEntity[businessConstants.RelationshipTypes.TOPIC_MEMBER_ID] = topicMemberParentArray;
            relationshipTypesArray.splice(topicMemberLocation, 1);
            entitiesArray.splice(topicMemberLocation, 1);
        }

        addEntityObj['relType'] = relationshipTypesArray.join(',');
        addEntityObj['parentEntity'] = this.currentContact.id;
        addEntityObj['childEntity'] = entitiesArray.join(';');
        addEntityObj['isCreateReciprocal'] = true;
        addEntityObj['isAppend'] = false;

        this._relationshipService.createMultipleRelationship(addEntityObj).pipe(
            catchError((err) => {
                this._toast.notify({
                    message: err.message,
                    style: NotificationStyles.Error
                });
                return of(null);
            })
        ).subscribe(response => {
            // only have the team or topic member, will send below request to server
            if ((isInTeamLocation > -1 || topicMemberLocation > -1) && this._currentUser.credential.manageTeam) {
                this._relationshipService.creatIsInTeamOrTopicMemberRelationship(isInteamOrTopicMemberObj).pipe(
                    catchError((err) => {
                        this._toast.notify({
                            message: err.message,
                            style: NotificationStyles.Error
                        });
                        return of(null);
                    })
                ).subscribe(res => { });
            }
        });
    }

    private _deleteMultiContactRelationshipType() {
        const relationshipTypes = this._getEmploymentData().relationships.map(item => item.relationshipType);
        const tempRelationshipArray = this._currentRelationshipArray.filter(item => !relationshipTypes.includes(item));
        if (tempRelationshipArray.length !== 0) {
            const addEntityObj = {};
            addEntityObj['relTypeId'] = tempRelationshipArray.join(',');
            addEntityObj['parentEntity'] = this.currentContact.id;
            addEntityObj['deletereciprocal'] = true;
            this._relationshipService.deleteRelationshipType(addEntityObj).pipe(
                catchError((err) => {
                    return of(null);
                })
            ).subscribe(data => { });
        }
    }

    private _deleteNewAddedControl(deleteControlGroupId, deleteType) {
        let deleteIndex;
        this.tplConfig.layout.forEach((item, index) => {
            if (item.trashId === deleteControlGroupId) {
                deleteIndex = index;
            }
        });
        // when click the trash btn, we need to remove the item from store, or the item will be saved
        for (const value in this._contactTemplateValueSet) {
            if (value.indexOf(deleteControlGroupId) !== -1) {
                delete this._contactTemplateValueSet[value];
            }
        }
        this.tplConfig.layout = this.tplConfig.layout.filter(item => {
            return item.trashId !== deleteControlGroupId;
        });
        if (deleteType === 'Position') {
            this._addBackControlTopValue(deleteIndex - 4, -116);
        } else {
            this._addBackControlTopValue(deleteIndex - 2, -50);
        }
    }


    private _detectDuplicatedEmail(newValue) {
        // only the duplicate controls can be added to the _duplicatedControls array
        const duplicateControlsIndex = this._duplicatedControls.findIndex(item =>
            newValue && newValue.emailValue && newValue.emailValue.ctrl && item === newValue.emailValue.ctrl.controlID);
        if (duplicateControlsIndex > -1 || this._duplicatedContactInfo.length === 0) {
            this._duplicatedContactInfo = [];
            this._duplicatedControls.splice(duplicateControlsIndex, 1);
            this.isDuplicatedContact = false;
            if (newValue && newValue.emailValue && newValue.emailValue.value) {
                this._dialogCloseDestroySubscriptions.push(
                    this._contactService.detectDuplicated([{
                        field: 'webEmail',
                        value: newValue.emailValue.value
                    }]).pipe(
                        catchError((err) => {
                            return of(null);
                        }),
                    ).subscribe(res => {
                        if (res && res.count > 0) {
                            this._duplicatedControls.push(newValue.emailValue.ctrl.controlID);
                            // show the alert message
                            this.isDuplicatedContact = true;
                            res['contact-list'].forEach(listItem => {
                                let jobTitle = '';
                                const contactInfo = [];
                                // get the job title value
                                if (listItem['web-job-title'].length > 0) {
                                    listItem['web-job-title'].forEach((jobTitleItem, index) => {
                                        if (index > 0) {
                                            jobTitle = jobTitle + ', ' + jobTitleItem['name'];
                                        } else {
                                            jobTitle = jobTitleItem['name'];
                                        }
                                    });
                                    contactInfo.push(
                                        {
                                            field: DuplicatedContactItemConfigField.JobTitle,
                                            value: jobTitle
                                        }
                                    );
                                }
                                // get the company value
                                if (listItem['web-company'] && listItem['web-company'].name) {
                                    contactInfo.push(
                                        {
                                            field: DuplicatedContactItemConfigField.Company,
                                            value: listItem['web-company'].name
                                        }
                                    );
                                }
                                // get the web email value
                                if (listItem['webEmail'].length > 0) {
                                    listItem['webEmail'].forEach(emailItem => {
                                        let emailField = '';
                                        if (emailItem['primaryEmail']) {
                                            emailField = DuplicatedContactItemConfigField.PrimaryEmail;
                                        } else {
                                            emailField = emailItem['name'] + ' Email';
                                        }
                                        contactInfo.push({
                                            field: emailField,
                                            value: emailItem['address']
                                        });
                                    });
                                    this._duplicatedContactInfo.push({
                                        contactName: listItem['first-name'] + ' ' + listItem['last-name'],
                                        contactId: listItem['id'],
                                        contactInfo: contactInfo,
                                        instanceId: this.dialogOpenOptions.instanceId,
                                        controlId: this.dialogOpenOptions.entityBack ? this.dialogOpenOptions.entityBack.controlId : ''
                                    });
                                }
                            });
                        }
                    })
                );
            }
        }
    }

    // feedback to note/entity dialog
    private _feedBackToPrivousDialog(contact: Contact) {
        const entityBack = new EntityBack();
        entityBack.controlId = this.dialogOpenOptions.entityBack.controlId;
        entityBack.entityId = contact.id;
        entityBack.searchValue = contact.name;
        entityBack.currentId = this.dialogOpenOptions.instanceId;
        this._openDynamicComponentService.feedbackSubject$.next(entityBack);
    }

    private _getDefaultContactTemplate(res) {
        this.tplConfig = res;
        this._dialogLabelArray = this.tplConfig.layout.filter(item => item.componentType === 'label');
        this._isRelationshipControlValueChanged = false;
        if (this.dialogOpenOptions && this.dialogOpenOptions.isBlastEmail) {
            for (const ctrl of this.tplConfig.layout) {
                if (ctrl.controlID === 'FirstName') {
                    ctrl.staticDefaultValue = this.dialogOpenOptions.contact.name;
                } else if (ctrl.controlID === 'LastName') {
                    ctrl.staticDefaultValue = this.dialogOpenOptions.contact.lastName;
                } else if (ctrl.controlID === 'WorkEmailValue') {
                    ctrl.staticDefaultValue = this.dialogOpenOptions.contact.primaryEmail;
                }
            }
        }
        if (this.dialogOpenOptions && this.dialogOpenOptions.contact) {
            for (const ctrl of this.tplConfig.layout) {
                if (ctrl.controlID === 'FirstName') {
                    ctrl.staticDefaultValue = this.dialogOpenOptions.contact.name;
                }
            }
        }
        if (this.dialogOpenOptions && this.dialogOpenOptions.contact && this.dialogOpenOptions.openType === ContactTemplateType.EditContact
            && this.dialogOpenOptions.contact.template) {
            this._setStaticDefaultValueForEdit(this.tplConfig);
            setTimeout(() => {
                this._setDynimacLayoutForEdit();
            }, 1000);
        } else {
            for (const ctrl of this.tplConfig.layout) {
                ctrl['openAction'] = this.dialogOpenOptions.openType;
                ctrl['prefixId'] = this.dialogOpenOptions.instanceId;
            }
        }
        this._store.dispatch(
            new ChangeContactTemplateLayoutSet(
                this.tplConfig.layout,
                'prefix',
                this.dialogOpenOptions.instanceId
            )
        );
    }

    // will get the current and former employment data for saving action
    private _getEmploymentData() {
        const _contactTemplateValueArray = Object.keys(this._contactTemplateValueSet).map((item, index) => ({ key: item, value: this._contactTemplateValueSet[item] }));
        const _employmentArray = [];
        const _relationshipArray = [];
        for (let i = 0; i < _contactTemplateValueArray.length; i++) {
            const _employmentDetail = new EmploymentDetail();
            const _currentItem = _contactTemplateValueArray[i];

            // start to get the current employment: jobtitle, company, and startDate
            // first need to get the job title array from basic information
            if (_currentItem.value.ctrl && _currentItem.value.ctrl.controlID &&
                _currentItem.value.ctrl.controlID.indexOf(ControlId.Current_Employment_JobTitle) !== -1
                // && this._newJobTitleArray.includes(_currentItem.value.ctrl.groupId)
            ) {
                _employmentDetail.companyID = this.currentContact.company;
                _employmentDetail.titleType = [_currentItem.value.value];
                for (let j = 0; j < _contactTemplateValueArray.length; j++) {
                    // according to the same groupId to get the companyid and start
                    if (_contactTemplateValueArray[j].value.ctrl.groupId === _currentItem.value.ctrl.groupId) {
                        if (_contactTemplateValueArray[j].value.ctrl.controlID.indexOf(ControlId.Current_Employment_StartYear) !== -1
                            && _contactTemplateValueArray[j].value.value) {
                            _employmentDetail.startDate = this._parseTime(Number(_contactTemplateValueArray[j].value.value));
                        } else {
                            _employmentDetail.startDate = 0;
                        }
                    }
                }
                _employmentArray.push(_employmentDetail);
            }
            // end to get the current employment

            // start to get the former employment: job title and end date cannot be empty
            // need to get the data: jobtitle, companyid, startdate, enddate
            if (_currentItem.value.ctrl && _currentItem.value.ctrl.controlID &&
                _currentItem.value.ctrl.controlID.indexOf(ControlId.Former_Employment_JobTitle) !== -1) {
                // find the former employment group and according to the jobtitle
                _employmentDetail.titleType = [_currentItem.value.value];
                _employmentDetail.companyID = '';
                _employmentDetail.endDate = 0;
                _employmentDetail.startDate = 0;
                for (let j = 0; j < _contactTemplateValueArray.length; j++) {
                    // according to the same groupId to get the companyid and start, end date
                    if (_contactTemplateValueArray[j].value.ctrl.groupId === _currentItem.value.ctrl.groupId) {
                        if (_contactTemplateValueArray[j].value.ctrl.controlID.indexOf(ControlId.Former_Employment_Company) !== -1) {
                            _employmentDetail.companyID = '';
                            _employmentDetail.companyID = _contactTemplateValueArray[j].value.value;
                        }

                        // end year cannot be empty
                        if (_contactTemplateValueArray[j].value.ctrl.controlID.indexOf(ControlId.Former_Employment_EndYear) !== -1) {
                            _employmentDetail.endDate = this._parseTime(Number(_contactTemplateValueArray[j].value.value));
                        }

                        if (_contactTemplateValueArray[j].value.ctrl.controlID.indexOf(ControlId.Former_Employment_StartYear) !== -1) {
                            if (_contactTemplateValueArray[j].value.value) {
                                _employmentDetail.startDate = this._parseTime(Number(_contactTemplateValueArray[j].value.value));
                            }
                        }
                    }
                }
                _employmentArray.push(_employmentDetail);
                // need to remove the same item
            }
            // end to get the former employment

            const _relationshipDetail = new RelationshipDetail();
            // start to get the relationship
            // need to get the data: relationship type and childentity
            if (_currentItem.value.ctrl && _currentItem.value.ctrl.controlID &&
                _currentItem.value.ctrl.controlID.indexOf(ControlId.AddRelationshipType) !== -1) {
                // find the former employment group and according to the jobtitle
                _relationshipDetail.relationshipType = _currentItem.value.value;
                if (_currentItem.value.ctrl.groupId) {
                    // groupid exists
                    for (let j = 0; j < _contactTemplateValueArray.length; j++) {
                        if (_contactTemplateValueArray[j].value.ctrl.groupId === _currentItem.value.ctrl.groupId &&
                            _contactTemplateValueArray[j].value.ctrl.controlID !== _currentItem.value.ctrl.controlID) {
                            _relationshipDetail.childEntity = _contactTemplateValueArray[j].value.value.split(',');
                        }
                    }
                }
                // below is to merge the same relationship type
                let isExisted = false;
                _relationshipArray.forEach(element => {
                    if (element.relationshipType === _relationshipDetail.relationshipType) {
                        element.childEntity = Array.from(new Set(element.childEntity.concat(_relationshipDetail.childEntity)));
                        isExisted = true;
                    }
                });
                if (!isExisted) {
                    _relationshipArray.push(_relationshipDetail);
                }
            }
            // end to get the relationship
        }
        return {
            employments: _employmentArray,
            relationships: _relationshipArray
        };
    }

    private _getCurrentYear() {
        return new Date().getFullYear();
    }

    // need to move to ct-text component
    // this function will do: when jobtitle changed in basic information, current employment should add the same
    // control according to the jobtitle
    private _handleEmploymentJobtitle(res) {
        let currentJobTitle = [];
        // need to remove the job title from store, now, have removed from contactTemplateValueSet, not remove from real store
        res.forEach(element => {
            let startYear = '';
            if (element.isEdit) {
                startYear = element.startYear;
            } else {
                for (const index in this._contactTemplateValueSet) {
                    if (index.indexOf(ControlId.Current_Employment_JobTitle) !== -1 && element.id === this._contactTemplateValueSet[index]['value']) {
                        for (const item in this._contactTemplateValueSet) {
                            if (item.indexOf(ControlId.Current_Employment_StartYear) !== -1 &&
                                this._contactTemplateValueSet[index]['ctrl']['groupId'] === this._contactTemplateValueSet[item]['ctrl']['groupId']) {
                                startYear = this._contactTemplateValueSet[item]['value'];
                            }
                        }
                    }
                }
            }
            currentJobTitle.push({
                id: element.id,
                value: element.value,
                startYear: startYear
            });
        });

        // need to remove the job title from store, now, have removed from contactTemplateValueSet, not remove from real store
        for (const index in this._contactTemplateValueSet) {
            if (index.indexOf(ControlId.Current_Employment_JobTitle) !== -1 || index.indexOf(ControlId.Current_Employment_StartYear) !== -1) {
                delete this._contactTemplateValueSet[index];
            }
        }
        const jobTitles = [];
        // this._newJobTitleArray = [];
        const _config = _lodash.cloneDeep(this.tplConfig);
        let employmentJobTitleTopValue = 0;
        let employmentJobTitleCount = 0;
        if (currentJobTitle.length === 0) {
            currentJobTitle = [''];
        }
        // get the total number of current employment control for the last time
        _config.layout.forEach((item, i) => {
            if (item.controlID === ControlId.Employment_Company_Key) {
                employmentJobTitleTopValue = Number(item.top) + 30;
            }
            if (item.controlID && ((item.controlID.indexOf(ControlId.Current_Employment_JobTitle) !== -1) ||
                (item.controlID.indexOf(ControlId.Current_Employment_StartYear) !== -1))) {
                employmentJobTitleCount++;
            }
        });
        currentJobTitle.forEach((item, i) => {
            const hashtime = new Date().getTime() + Math.floor(Math.random() * 9999 + 1);
            const Current_Employment_JobTitle = {};
            const Current_Employment_StartYear = {};

            Current_Employment_JobTitle['openAction'] = this.dialogOpenOptions.openType;
            Current_Employment_StartYear['openAction'] = this.dialogOpenOptions.openType;
            Current_Employment_JobTitle['prefixId'] = this.dialogOpenOptions.instanceId;
            Current_Employment_StartYear['prefixId'] = this.dialogOpenOptions.instanceId;
            Current_Employment_JobTitle['isRequired'] = false;
            Current_Employment_JobTitle['componentType'] = 'input';
            // tslint:disable-next-line: radix
            Current_Employment_JobTitle['top'] = Number(employmentJobTitleTopValue) + (i) * 60;
            Current_Employment_JobTitle['left'] = 10;
            Current_Employment_JobTitle['heigh'] = 30;
            Current_Employment_JobTitle['isLabelHidden'] = false;
            Current_Employment_JobTitle['width'] = 315;
            Current_Employment_JobTitle['labelwidth'] = 30;
            Current_Employment_JobTitle['controlID'] = 'Current_Employment_JobTitle' + hashtime;
            Current_Employment_JobTitle['isHidden'] = false;
            Current_Employment_JobTitle['trashId'] = hashtime;
            Current_Employment_JobTitle['groupId'] = hashtime;
            Current_Employment_JobTitle['type'] = 'Current_Employment_JobTitle';
            Current_Employment_JobTitle['hint'] = item.value;
            Current_Employment_JobTitle['label'] = 'Job Title';
            Current_Employment_JobTitle['isDisabled'] = true;
            if (this.dialogOpenOptions.openType === ContactTemplateType.EditContact) {
                Current_Employment_JobTitle['staticDefaultValue'] = {
                    childEntityName: (this._contactTemplateValueSet['Company'] && this._contactTemplateValueSet['Company'].displayValue) ? this._contactTemplateValueSet['Company'].displayValue : '',
                    childEntityId: (this._contactTemplateValueSet['Company'] && this._contactTemplateValueSet['Company'].value) ? this._contactTemplateValueSet['Company'].value : '',
                    relationshipTypeId: item.id,
                    relationshipTypeName: item.value
                };
            }
            const value = new ContactTemplateControlValue(item.id, item.value, Current_Employment_JobTitle);
            this._store.dispatch(
                new ChangeContactTemplateValueSet(
                    value,
                    'prefix',
                    this.dialogOpenOptions.instanceId
                )
            );

            Current_Employment_StartYear['isRequired'] = false;
            Current_Employment_StartYear['componentType'] = 'dropdown';
            Current_Employment_StartYear['top'] = Number(employmentJobTitleTopValue) + (i) * 60;
            Current_Employment_StartYear['left'] = 335;
            Current_Employment_StartYear['heigh'] = 30;
            Current_Employment_StartYear['isLabelHidden'] = false;
            Current_Employment_StartYear['width'] = 315;
            Current_Employment_StartYear['labelwidth'] = 30;
            Current_Employment_StartYear['controlID'] = 'Current_Employment_StartYear' + hashtime;
            Current_Employment_StartYear['isHidden'] = false;
            Current_Employment_StartYear['trashId'] = hashtime;
            Current_Employment_StartYear['groupId'] = hashtime;
            Current_Employment_StartYear['type'] = 'Current_Employment_StartYear';
            Current_Employment_StartYear['label'] = 'Start Year';
            if (this.dialogOpenOptions.openType === ContactTemplateType.EditContact) {
                if (item.startYear) {
                    Current_Employment_StartYear['staticDefaultValue'] = item.startYear;
                } else {
                    Current_Employment_StartYear['staticDefaultValue'] = '';
                }
            }

            jobTitles.push(Current_Employment_JobTitle);
            jobTitles.push(Current_Employment_StartYear);
        });
        _config.layout.forEach((item, i) => {
            if (item.controlID === ControlId.Employment_Company_Value) {
                // first need to remove the old current employment control
                this.tplConfig.layout.splice(i + 1, employmentJobTitleCount);
                this._addBackControlTopValue(i + 1, -employmentJobTitleCount / 2 * 60);
                // second to add the new current employment control
                for (let j = 0; j < jobTitles.length; j++) {
                    this.tplConfig.layout.splice(i + j + 1, 0, jobTitles[j]);
                }
                this._addBackControlTopValue(i + jobTitles.length + 1, jobTitles.length / 2 * 60);
            }
        });
    }

    private _initContact() {
        // Temporary code in order to modify the json
        // this.tplConfig = _lodash.cloneDeep(DefaultContactTemplateConfiguration);
        this._destroySubscriptions.push(
            this._contactService.getContactTemplate(businessConstants.EntityTypes.Contact_Id)
                .subscribe(res => this._getDefaultContactTemplate(res)));
    }

    private _moveCurrentEmploymentToFormerEmployment(originalCompany, targetCompany) {
        if (originalCompany) {
            // tslint:disable-next-line: forin
            for (const index in this._contactTemplateValueSet) {
                let originalCurrentEmployment;
                if (index.indexOf(ControlId.Current_Employment_JobTitle) !== -1 && this._contactTemplateValueSet[index].value) {
                    let _startYear = 0;
                    for (const item in this._contactTemplateValueSet) {
                        if ((item.indexOf(ControlId.Current_Employment_StartYear) !== -1)
                            && (this._contactTemplateValueSet[index].ctrl.groupId === this._contactTemplateValueSet[item].ctrl.groupId)) {
                            _startYear = this._contactTemplateValueSet[item].value;
                            delete this._contactTemplateValueSet[item];
                        }
                    }
                    if (this._contactTemplateValueSet[index].ctrl.staticDefaultValue) {
                        originalCurrentEmployment = {
                            relationshipId: this._contactTemplateValueSet[index].ctrl.staticDefaultValue.relationshipId,
                            childEntityName: originalCompany.name || '',
                            childEntityId: originalCompany.id || '',
                            relationshipTypeId: this._contactTemplateValueSet[index].ctrl.staticDefaultValue.relationshipTypeId,
                            relationshipTypeName: this._contactTemplateValueSet[index].ctrl.staticDefaultValue.relationshipTypeName,
                            startYear: _startYear,
                            endYear: this._getCurrentYear()
                        };
                        delete this._contactTemplateValueSet[index];
                        const _hashtime = new Date().getTime();
                        this._addedFormerEmploymentCtrlGroupId.push(_hashtime);
                        this._contactTemplateService.addDynimacLayoutSubject$.next({
                            action: ControlId.AddNewPosition,
                            type: 'Position',
                            value: originalCurrentEmployment,
                            hashtime: _hashtime,
                            prefixId: this.dialogOpenOptions.instanceId
                        });
                    }
                }
            }
            // to clear the job title control
            this._contactTemplateService.actionSubject$.next({
                type: JobTitleAction.ClearJobTitile,
                payload: 'JobTitle'
            });
        }
    }

    private _parseTime(year: Number) {
        const _currentYear = year.toString() + '/01/30 00:00:00';
        return (new Date(_currentYear)).getTime();
    }

    private _parseTimeToStandardTime(milTime) {
        let date;
        if (milTime === 0) {
            date = 0;
        } else {
            date = new Date(milTime).getFullYear();
        }
        return date;
    }

    private _processConfigValue(res) {
        this._contactTemplateValueSet = res;
    }

    private _processAddress() {
        // tslint:disable-next-line: forin
        for (const controlId in this._contactTemplateValueSet) {
            const ctrl = this._contactTemplateValueSet[controlId];
            if (ctrl.ctrl.componentType === 'singleDropdown' && ctrl.ctrl.controlID.indexOf('AddressKey') !== -1) {
                const _addressDetal = new AddressDetail();
                _addressDetal.name = ctrl.value;
                let changeCountryOrState = false;
                // tslint:disable-next-line: forin
                for (const controlIdValue in this._contactTemplateValueSet) {
                    const ctrlValue = this._contactTemplateValueSet[controlIdValue];
                    if (ctrl.ctrl.groupId && ctrlValue.ctrl.groupId && ctrl.ctrl.groupId === ctrlValue.ctrl.groupId &&
                        ctrlValue.ctrl.controlID.indexOf('AddressKey') === -1) {
                        if (ctrlValue.ctrl.controlID.indexOf('country') !== -1) {
                            _addressDetal.country = ctrlValue.value;
                            changeCountryOrState = ctrlValue.ctrl.changeCountryOrState;
                        } else if (ctrlValue.ctrl.controlID.indexOf('street1') !== -1) {
                            _addressDetal.street = ctrlValue.value;
                        } else if (ctrlValue.ctrl.controlID.indexOf('street2') !== -1) {
                            _addressDetal.street2 = ctrlValue.value;
                        } else if (ctrlValue.ctrl.controlID.indexOf('city') !== -1) {
                            _addressDetal.city = ctrlValue.value;
                        } else if (ctrlValue.ctrl.controlID.indexOf('state') !== -1) {
                            _addressDetal.state = ctrlValue.value;
                            changeCountryOrState = ctrlValue.ctrl.changeCountryOrState;
                        } else if (ctrlValue.ctrl.controlID.indexOf('zip') !== -1) {
                            _addressDetal.zip = ctrlValue.value;
                        }
                    }
                }
                const createInvalidAddress = _addressDetal.street || _addressDetal.street2 || _addressDetal.city || _addressDetal.zip || changeCountryOrState;
                if (this.dialogOpenOptions.openType === ContactTemplateType.NewContact && createInvalidAddress || this.dialogOpenOptions.openType === ContactTemplateType.EditContact) {
                    this.currentContact.webAddress.push(_addressDetal);
                }
            }
        }
    }

    private _processDataBeforeSave() {
        this.currentContact = new Contact();
        if (this.dialogOpenOptions.openType === ContactTemplateType.EditContact) {
            this.currentContact.id = this.dialogOpenOptions.contact.id;
            this.currentContact.defaultRelationshipType = this.dialogOpenOptions.contact.defaultRelationshipType;
        }
        this._processAddress();
        // tslint:disable-next-line: forin
        for (const controlId in this._contactTemplateValueSet) {
            const ctrl = this._contactTemplateValueSet[controlId];
            // tslint:disable-next-line: forin
            for (const controlIdValue in this._contactTemplateValueSet) {
                const ctrlValue = this._contactTemplateValueSet[controlIdValue];
                if ((ctrl.ctrl.componentType === 'singleDropdown' || (ctrl.ctrl.controlID === 'WorkEmailkey' && ctrl.ctrl.componentType === 'input')) &&
                    ctrl.ctrl.groupId && ctrlValue.ctrl.groupId && ctrl.ctrl.groupId === ctrlValue.ctrl.groupId
                    && (ctrlValue.ctrl.componentType === 'input' || (ctrlValue.ctrl.componentType === 'singleDropdown' && (ctrlValue.ctrl.controlID.indexOf('country') !== -1) || ctrlValue.ctrl.controlID.indexOf('state') !== -1))) {
                    if (ctrl.ctrl.type && ctrl.ctrl.type.toLowerCase() === 'phone') {
                        this.currentContact.webPhone[ctrl.value] = ctrlValue.value;
                        const phoneDetail = new PhoneDetail();
                        phoneDetail.phone = ctrlValue.value;
                        phoneDetail.name = ctrl.value;
                        // phoneDetail.groupId = ctrl.ctrl.groupId;
                        this.currentContact.webPhone.push(phoneDetail);
                    } else if (ctrl.ctrl.type === 'Email') {
                        const emailDetail = new EmailDetail();
                        emailDetail.address = ctrlValue.value;
                        emailDetail.name = ctrl.value;
                        emailDetail.primaryEmail = ctrlValue.ctrl['isPrimary'] || false;
                        this.currentContact.webEmail.push(emailDetail);
                        if (emailDetail.primaryEmail) {
                            this.currentContact.primaryEmail = ctrlValue.value;
                        }
                    } else if (ctrl.ctrl.type === 'Internet') {
                        const socialMedia = new SocialMedia();
                        socialMedia.name = ctrl.value;
                        socialMedia.link = ctrlValue.value;
                        this.currentContact.socialMedia.push(socialMedia);
                    }
                }
            }

            switch (controlId) {
                case 'FirstName':
                    this.currentContact.firstName = ctrl.value;
                    break;
                case 'LastName':
                    this.currentContact.lastName = ctrl.value;
                    break;
                case 'Alias':
                    this.currentContact.aliases = ctrl.value;
                    this.currentContact.template.aliasHeight = ctrl.ctrl.newHeight;
                    break;
                case 'Company':
                    // when send request to server, the company stands for companyid
                    // when get response from server, the company stands for a json: company id, company name, company short name
                    this.currentContact.company = ctrl.value;
                    break;
                case 'JobTitle':
                    this._relationshipTypes = ctrl.value;
                    this.currentContact.jobTitle = ctrl.value.split(',');
                    this.currentContact.template.jobTitleHeight = ctrl.ctrl.newHeight;
                    break;
                case 'JobFunction':
                    const jobfunction = new JobFunction();
                    jobfunction.new = ctrl.value;
                    this.currentContact.jobFunction = jobfunction;
                    this.currentContact.template.jobFunctionHeight = ctrl.ctrl.newHeight;
                    break;
                case 'Notes':
                    this.currentContact.notes = ctrl.value;
                    break;
                case 'WorkEmailValue':
                    if (this.dialogOpenOptions.isBlastEmail) {
                        this.currentContact.primaryEmail = ctrl.value;
                    }
                    break;
                case 'Birthday':
                    this.currentContact.birthday = ctrl.displayValue;
                    break;
                case ControlId.Prefix:
                    this.currentContact.birthday = ctrl.displayValue;
                    break;
            }
        }
        this.currentContact.employment = this._getEmploymentData().employments;
        this.currentContact.relationship = this._getEmploymentData().relationships;
        // after all case pass ,it will be delete.
        // this.currentContact.template = this.tplConfig;
    }

    // this function need to save current employment when user create the invalid company and then click the cancel button
    // the current employment should be saved though user click the cancel button
    private _saveCurrentEmployment(newCreatedCompany: Entity): void {
        // tslint:disable-next-line: forin
        for (const index in this._contactTemplateValueSet) {
            const ctrl = this._contactTemplateValueSet[index];
            const titleType = ctrl.value && ctrl.value.length > 0 ? ctrl.value.split(',').filter(item => item.indexOf('fakeId') === -1) : '';
            if (ctrl.ctrl.controlID === 'JobTitle' && titleType && titleType.length > 0) {
                const currentEmployment = {
                    contactID: this.currentContact.id,
                    companyID: newCreatedCompany.id,
                    startDate: 0,
                    titleType: titleType,
                };
                this._contactService.createContactEmployment(currentEmployment).subscribe(res => { });
            }
        }
    }

    private _setDynimacLayoutForEdit() {
        const dynamicConfig: any = {};
        dynamicConfig['openAction'] = this.dialogOpenOptions.openType;
        dynamicConfig['prefixId'] = this.dialogOpenOptions.instanceId;
        if (this.currentContact) {
            if (this.currentContact.webAddress.length > 1) {
                dynamicConfig['action'] = 'AddAddress';
                dynamicConfig['type'] = 'Address';
                for (let i = 1; i < this.currentContact.webAddress.length; i++) {
                    dynamicConfig['value'] = this.currentContact.webAddress[i];
                    this._contactTemplateService.addDynimacLayoutSubject$.next(dynamicConfig);
                }
            }

            if (this.currentContact.webPhone && this.currentContact.webPhone.length > 1) {
                dynamicConfig['action'] = 'AddPhoneNumber';
                dynamicConfig['type'] = 'Phone';
                for (let i = 1; i < this.currentContact.webPhone.length; i++) {
                    dynamicConfig.value = this.currentContact.webPhone[i];
                    this._contactTemplateService.addDynimacLayoutSubject$.next(dynamicConfig);
                }
            }

            if (this.currentContact.webEmail.length > 1) {
                dynamicConfig['action'] = 'AddEmail';
                dynamicConfig['type'] = 'Email';
                for (let i = 1; i < this.currentContact.webEmail.length; i++) {
                    dynamicConfig['value'] = this.currentContact.webEmail[i];
                    this._contactTemplateService.addDynimacLayoutSubject$.next(dynamicConfig);
                }
            }

            if (this.currentContact.socialMedia.length > 1) {
                dynamicConfig['action'] = 'AddInternetInfo';
                dynamicConfig['type'] = 'Internet';
                for (let i = 1; i < this.currentContact.socialMedia.length; i++) {
                    dynamicConfig['value'] = this.currentContact.socialMedia[i];
                    this._contactTemplateService.addDynimacLayoutSubject$.next(dynamicConfig);
                }
            }
        }

        // set dynamic layout for relationship
        if (this.currentContactRelationshipAndEmployment.relationships.length > 1) {
            dynamicConfig['action'] = ControlId.AddRelationships;
            dynamicConfig['type'] = 'Relationship';
            for (let i = 1; i < this.currentContactRelationshipAndEmployment.relationships.length; i++) {
                const tempValue = this.currentContactRelationshipAndEmployment.relationships[i];
                dynamicConfig['value'] = {
                    relationshipType: {
                        relationshipTypeId: tempValue.relationshipType.relationshipTypeId || '',
                        isNodeEditable: tempValue.relationshipType.isNodeEditable
                    },
                    relationshipEntities: tempValue.relationshipEntities || []
                };
                this._contactTemplateService.addDynimacLayoutSubject$.next(dynamicConfig);
            }
        }

        // set dynamic layout for former employment
        if (this.currentContactRelationshipAndEmployment.formerEmployment.length > 0) {
            dynamicConfig['action'] = ControlId.AddNewPosition;
            dynamicConfig['type'] = 'Position';
            for (let i = 0; i < this.currentContactRelationshipAndEmployment.formerEmployment.length; i++) {
                const tempValue = this.currentContactRelationshipAndEmployment.formerEmployment[i];
                dynamicConfig['hashtime'] = new Date().getTime() + Math.floor(Math.random() * 9999 + 1);
                dynamicConfig['value'] = {
                    relationshipTypeId: tempValue.relationshipTypeId || '',
                    childEntityId: tempValue.childEntityId || '',
                    startYear: tempValue.startYear || '',
                    endYear: tempValue.endYear || ''
                };
                this._contactTemplateService.addDynimacLayoutSubject$.next(dynamicConfig);
            }
        }

        // set dynamic layout for current employment
        if (this.currentContactRelationshipAndEmployment.currentEmployment.length > 0) {
            const currentEmployment = [];
            if (this.currentContactRelationshipAndEmployment.currentEmployment.length === this.currentContact.jobTitleWeb.length) {
                this.currentContactRelationshipAndEmployment.currentEmployment.forEach(currentEmploymentItem => {
                    currentEmployment.push({
                        id: currentEmploymentItem.relationshipTypeId || '',
                        value: currentEmploymentItem.relationshipTypeName || '',
                        startYear: currentEmploymentItem.startYear || 0,
                        isEdit: true
                    });
                });
                this._handleEmploymentJobtitle(currentEmployment);
            } else {
                // the job title length > current employment length
                // for this part, will handle: if user add the invalid job title in richclient, the current employment should show
                let fakeId = 0;
                this.currentContact.jobTitleWeb.forEach(jobTitleItem => {
                    let _index = 0;
                    if (this.currentContactRelationshipAndEmployment.currentEmployment.some((currentItem, index) => {
                        _index = index;
                        return jobTitleItem.id === currentItem.relationshipTypeId;
                    })) {
                        currentEmployment.push({
                            id: jobTitleItem.id || '',
                            value: jobTitleItem.name || '',
                            startYear: this.currentContactRelationshipAndEmployment.currentEmployment[_index].startYear || 0,
                            isEdit: true
                        });
                    } else {
                        currentEmployment.push({
                            id: 'fakeId' + fakeId++,
                            value: jobTitleItem.name || '',
                            startYear: 0,
                            isEdit: true
                        });
                    }
                });
                this._handleEmploymentJobtitle(currentEmployment);
            }
        }
    }

    private _setConfig(config: any) {
        for (const row of config) {
            for (const ctrl of row) {
                if (ctrl.componentType === 'group' || ctrl.componentType === 'virtualgroup') {
                    ctrl.contains = Array.from(this._setConfig(ctrl.contains));
                } else {
                }
            }
            return config;
        }
    }

    private _verifyInput() {
        const phoneReg = /^[\+a-z\A-Z0-9\-().\+\s]{1,25}$/;
        const emailReg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
        const firstNameCondition = this.currentContact.firstName && this.currentContact.firstName.indexOf(',') < 1;
        const formerEmploymentEndDateCondition = this.currentContact.employment.filter(item =>
            item.hasOwnProperty('endDate') && (item.endDate === 0)).length === 0;
        const allEmail = this.currentContact.webEmail.filter(item => item.address && (!emailReg.test(item.address))).length === 0;
        const allPhone = this.currentContact.webPhone.filter(item => item.phone && (!phoneReg.test(item.phone))).length === 0;
        if (firstNameCondition && formerEmploymentEndDateCondition && allEmail && allPhone) {
            return true;
        } else {
            let name = 'BASIC INFORMATION';
            if (!firstNameCondition) {
                name = 'BASIC INFORMATION';
            } else if (!allPhone || !allEmail) {
                name = 'CONTACT INFORMATION';
            } else if (!formerEmploymentEndDateCondition) {
                name = 'EMPLOYMENT';
            }
            const location = { 'instanceId': this.dialogOpenOptions.instanceId, 'name': name };
            this._changeDialogSection(location);
            this._contactTemplateService.validInputSubject$.next('');
            return false;
        }
    }
}
